import { render, staticRenderFns } from "./Setting.vue?vue&type=template&id=5a4131e7&scoped=true"
import script from "./Setting.vue?vue&type=script&lang=js"
export * from "./Setting.vue?vue&type=script&lang=js"
import style0 from "./Setting.vue?vue&type=style&index=0&id=5a4131e7&prod&lang=scss"
import style1 from "./Setting.vue?vue&type=style&index=1&id=5a4131e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4131e7",
  null
  
)

export default component.exports